import { Controller } from '@hotwired/stimulus'

// Live, client-side voice picker filtering for the voice playground. Wrap the
// picker with data-controller="voice-filter". A search box filters by the card's
// data-name (case-insensitive substring); the role/gender/language selects filter
// by the card's data-role / data-gender / data-language attrs (an empty select
// value = "all" = matches anything). Each voice card is an `item` target; on every
// input/change we show/hide cards, update the `count` target, and toggle the
// `empty` "no matches" message. Dependency-free and resilient (guards hasXTarget).
//
//   data-controller="voice-filter"
//   search input  → data-voice-filter-target="search" data-action="input->voice-filter#filter"
//   role/gender/language/service selects → matching target + data-action="change->voice-filter#filter"
//   each card → data-voice-filter-target="item" data-name=".." data-role=".." data-gender=".." data-language=".." data-provider=".."
//   count element → data-voice-filter-target="count"
//   empty message → data-voice-filter-target="empty" (hidden by default)
export default class extends Controller {
  static targets = ['item', 'search', 'role', 'gender', 'language', 'service', 'count', 'empty']

  connect() {
    this.filter()
  }

  filter() {
    const term = this.hasSearchTarget ? this.searchTarget.value.trim().toLowerCase() : ''
    const role = this.hasRoleTarget ? this.roleTarget.value : ''
    const gender = this.hasGenderTarget ? this.genderTarget.value : ''
    const language = this.hasLanguageTarget ? this.languageTarget.value : ''
    const service = this.hasServiceTarget ? this.serviceTarget.value : ''

    let visible = 0
    this.itemTargets.forEach((item) => {
      const matches =
        this.matchesText(item, term) &&
        this.matchesAttr(item, 'role', role) &&
        this.matchesAttr(item, 'gender', gender) &&
        this.matchesAttr(item, 'language', language) &&
        this.matchesAttr(item, 'provider', service)

      item.hidden = !matches
      if (matches) visible += 1
    })

    if (this.hasCountTarget) {
      this.countTarget.textContent = this.countTarget.dataset.template
        ? this.countTarget.dataset.template.replace('%{count}', visible)
        : String(visible)
    }
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible !== 0
  }

  matchesText(item, term) {
    if (!term) return true
    const name = (item.dataset.name || '').toLowerCase()
    return name.includes(term)
  }

  matchesAttr(item, key, value) {
    if (!value) return true
    return (item.dataset[key] || '') === value
  }
}
